import { render, staticRenderFns } from "./calendar-old-dates-list.vue?vue&type=template&id=7415c3b4"
import script from "./calendar-old-dates-list.vue?vue&type=script&lang=js"
export * from "./calendar-old-dates-list.vue?vue&type=script&lang=js"
import style0 from "./calendar-old-dates-list.vue?vue&type=style&index=0&id=7415c3b4&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports